/**
 * @generated SignedSource<<551d2472d0264ae0271956988cb11555>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PortfolioProjectTextCoverStyle = "COLOR_BLACK" | "COLOR_BLUE" | "COLOR_GREEN" | "COLOR_ORANGE" | "COLOR_PURPLE" | "COLOR_SALMON" | "COLOR_WATERMELON" | "COLOR_WHITE" | "COLOR_YELLOW" | "SHAPE_COINS_DARK" | "SHAPE_COINS_LIGHT" | "SHAPE_COLLABORATION_DARK" | "SHAPE_COLLABORATION_LIGHT" | "SHAPE_FOCUS_DARK" | "SHAPE_FOCUS_LIGHT" | "SHAPE_GAIN_DARK" | "SHAPE_GAIN_LIGHT" | "SHAPE_STAIRS_DARK" | "SHAPE_STAIRS_LIGHT" | "SHAPE_WAVE_DARK" | "SHAPE_WAVE_LIGHT" | "SVG_BLUE" | "SVG_BLUE2" | "SVG_LINES_BLUE" | "SVG_LINES_GREEN" | "SVG_LINES_ORANGE" | "SVG_LINES_PURPLE" | "SVG_LINES_SALMON" | "SVG_LINES_YELLOW" | "SVG_WHITE" | "SVG_WHITE2" | "SVG_YELLOW" | "SVG_YELLOW2" | "VAPOR_GRADIENT_BLUE_DARK" | "VAPOR_GRADIENT_BLUE_LIGHT" | "VAPOR_GRADIENT_GREEN_DARK" | "VAPOR_GRADIENT_GREEN_LIGHT" | "VAPOR_GRADIENT_PURPLE_DARK" | "VAPOR_GRADIENT_PURPLE_LIGHT" | "VAPOR_GRADIENT_SALMON_DARK" | "VAPOR_GRADIENT_SALMON_LIGHT" | "VAPOR_GRADIENT_WATERMELON_DARK" | "VAPOR_GRADIENT_WATERMELON_LIGHT" | "VAPOR_GRADIENT_WHITE_DARK" | "VAPOR_GRADIENT_YELLOW_LIGHT" | "%future added value";
export type ProductizedServicePriceInterval = "DAY" | "HOUR" | "MONTH" | "WEEK" | "%future added value";
export type ProductizedServicePriceType = "CONTACT_FOR_PRICING" | "FIXED_PRICE" | "RATE" | "%future added value";
export type SocialMediaSiteNid = "ANGELLIST" | "ARTSTATION" | "AWWWARDS" | "BEHANCE" | "CARBONMADE" | "DEV" | "DEVIANTART" | "DRIBBBLE" | "FACEBOOK" | "FIVERR" | "FREELANCER" | "FWA" | "GITHUB" | "GITLAB" | "HASHNODE" | "INSTAGRAM" | "LINKEDIN" | "MEDIUM" | "PATREON" | "PINTEREST" | "SOUNDCLOUD" | "STACKOVERFLOW" | "TIKTOK" | "TUMBLR" | "TWITCH" | "TWITTER" | "UPWORK" | "VIMEO" | "VKONTAKTE" | "WNW" | "X" | "YOUTUBE" | "%future added value";
export type ServicePageQuery$variables = {
  slug: string;
  url: string;
  username: string;
};
export type ServicePageQuery$data = {
  readonly productizedServiceBySlug: {
    readonly analyticsId: number;
    readonly blocknoteContent: any | null;
    readonly deliverables: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly createdAt: ContraAPIScalars.DateTime;
          readonly description: string;
          readonly id: string;
          readonly sortOrder: number;
          readonly title: string;
        };
      }>;
    };
    readonly id: string;
    readonly portfolioProjects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly cover: {
            readonly __typename: "PortfolioProjectImageCover";
            readonly image: {
              readonly animated: boolean;
              readonly height: number;
              readonly id: string;
              readonly originalFormat: string;
              readonly sizeBytes: number;
              readonly uid: string;
              readonly width: number;
            };
          } | {
            readonly __typename: "PortfolioProjectTextCover";
            readonly style: PortfolioProjectTextCoverStyle;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          };
          readonly id: string;
          readonly slug: string;
          readonly title: string;
        };
      }>;
    };
    readonly price: {
      readonly amount: number | null;
      readonly interval: ProductizedServicePriceInterval | null;
      readonly timeline: string | null;
      readonly type: ProductizedServicePriceType;
    };
    readonly roles: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string;
        };
      }>;
    };
    readonly slug: string;
    readonly title: string;
    readonly tools: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly logoImage: {
            readonly id: string;
            readonly uid: string;
          } | null;
          readonly name: string;
        };
      }>;
    };
    readonly userProfile: {
      readonly displayUsername: string;
      readonly externalLinks: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly label: string | null;
            readonly socialMediaSite: {
              readonly nid: SocialMediaSiteNid;
            } | null;
            readonly url: string;
          };
        }>;
      };
      readonly firstName: string | null;
      readonly generalInquiryCtaIsVisible: boolean;
      readonly id: string;
      readonly lastName: string | null;
      readonly portfolioProjects: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          };
        }>;
      };
      readonly " $fragmentSpreads": FragmentRefs<"Footer_userProfile" | "Services_userProfile">;
    };
    readonly visitorCanEdit: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"Service_productizedService">;
  } | null;
  readonly userProfileByUsername: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserProfile_userProfile">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"IndependentPortfolioTemplates_queryFragment" | "UrlMetaData_queryFragment">;
};
export type ServicePageQuery = {
  response: ServicePageQuery$data;
  variables: ServicePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "url"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "analyticsId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blocknoteContent",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitorCanEdit",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "animated",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sizeBytes",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "ContraImage",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "originalFormat",
      "storageKey": null
    },
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "style",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductizedServiceDeliverableConnection",
  "kind": "LinkedField",
  "name": "deliverables",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductizedServiceDeliverableEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductizedServiceDeliverable",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v16/*: any*/),
            (v17/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sortOrder",
              "storageKey": null
            },
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "interval",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductizedServicePrice",
  "kind": "LinkedField",
  "name": "price",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    (v19/*: any*/),
    (v20/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeline",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v23 = [
  (v2/*: any*/),
  (v22/*: any*/)
],
v24 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Role",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": (v23/*: any*/),
    "storageKey": null
  }
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductizedServiceRoleConnection",
  "kind": "LinkedField",
  "name": "roles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductizedServiceRoleEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": (v24/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = [
  (v2/*: any*/),
  (v12/*: any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "ContraImage",
  "kind": "LinkedField",
  "name": "logoImage",
  "plural": false,
  "selections": (v26/*: any*/),
  "storageKey": null
},
v28 = [
  (v2/*: any*/),
  (v22/*: any*/),
  (v27/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductizedServiceToolConnection",
  "kind": "LinkedField",
  "name": "tools",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductizedServiceToolEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Tool",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v28/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayUsername",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "generalInquiryCtaIsVisible",
  "storageKey": null
},
v34 = {
  "kind": "Literal",
  "name": "excludeDrafts",
  "value": true
},
v35 = [
  (v34/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "PROJECT"
  }
],
v36 = [
  (v2/*: any*/)
],
v37 = {
  "alias": null,
  "args": (v35/*: any*/),
  "concreteType": "UserProfilePortfolioProjectConnection",
  "kind": "LinkedField",
  "name": "portfolioProjects",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfilePortfolioProjectEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfolioProject",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v36/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "portfolioProjects(excludeDrafts:true,type:\"PROJECT\")"
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nid",
  "storageKey": null
},
v41 = [
  {
    "kind": "Variable",
    "name": "username",
    "variableName": "username"
  }
],
v42 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "cover",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*: any*/)
      ],
      "type": "PortfolioProjectImageCover",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v15/*: any*/)
      ],
      "type": "PortfolioProjectTextCover",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v43 = [
  (v34/*: any*/)
],
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productizedServiceType",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductizedServiceDuration",
  "kind": "LinkedField",
  "name": "duration",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v19/*: any*/)
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onlyVisibleToRecipient",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPositiveReview",
  "storageKey": null
},
v48 = [
  (v2/*: any*/),
  (v40/*: any*/)
],
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "developmentSlug",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v51 = [
  (v2/*: any*/),
  (v12/*: any*/),
  (v39/*: any*/)
],
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLive",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ServicePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProductizedService",
        "kind": "LinkedField",
        "name": "productizedServiceBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductizedServicePortfolioProjectConnection",
            "kind": "LinkedField",
            "name": "portfolioProjects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductizedServicePortfolioProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "cover",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v14/*: any*/)
                            ],
                            "type": "PortfolioProjectImageCover",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v15/*: any*/)
                            ],
                            "type": "PortfolioProjectTextCover",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v18/*: any*/),
          (v21/*: any*/),
          (v25/*: any*/),
          (v29/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "userProfile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v37/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileExternalLinkConnection",
                "kind": "LinkedField",
                "name": "externalLinks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfileExternalLinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfileExternalLink",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SocialMediaSite",
                            "kind": "LinkedField",
                            "name": "socialMediaSite",
                            "plural": false,
                            "selections": [
                              (v40/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Services_userProfile"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Footer_userProfile"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Service_productizedService"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v41/*: any*/),
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "userProfileByUsername",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserProfile_userProfile"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UrlMetaData_queryFragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "IndependentPortfolioTemplates_queryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServicePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProductizedService",
        "kind": "LinkedField",
        "name": "productizedServiceBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductizedServicePortfolioProjectConnection",
            "kind": "LinkedField",
            "name": "portfolioProjects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductizedServicePortfolioProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v4/*: any*/),
                      (v42/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v18/*: any*/),
          (v21/*: any*/),
          (v25/*: any*/),
          (v29/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "userProfile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v37/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileExternalLinkConnection",
                "kind": "LinkedField",
                "name": "externalLinks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfileExternalLinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfileExternalLink",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SocialMediaSite",
                            "kind": "LinkedField",
                            "name": "socialMediaSite",
                            "plural": false,
                            "selections": [
                              (v40/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v43/*: any*/),
                "concreteType": "UserProfileProductizedServiceConnection",
                "kind": "LinkedField",
                "name": "productizedServices",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfileProductizedServiceEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductizedService",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductizedServicePortfolioProjectConnection",
                            "kind": "LinkedField",
                            "name": "portfolioProjects",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductizedServicePortfolioProjectEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PortfolioProject",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v2/*: any*/),
                                      (v5/*: any*/),
                                      (v4/*: any*/),
                                      (v42/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "productizedServices(excludeDrafts:true)"
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserReviewConnection",
                "kind": "LinkedField",
                "name": "userReviews",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserReviewEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserReview",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v44/*: any*/),
          (v45/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductizedServiceFAQConnection",
            "kind": "LinkedField",
            "name": "faqs",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductizedServiceFAQEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductizedServiceFAQ",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "question",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "answer",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v23/*: any*/),
                "type": "Role",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v28/*: any*/),
                "type": "Tool",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v36/*: any*/),
                "type": "Node",
                "abstractKey": "__isNode"
              },
              {
                "kind": "InlineFragment",
                "selections": (v36/*: any*/),
                "type": "IndustryCategory",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v36/*: any*/),
                "type": "ProductCustomTag",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v41/*: any*/),
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "userProfileByUsername",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileDisplayType",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bio",
            "storageKey": null
          },
          (v7/*: any*/),
          (v33/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasActivePortfolio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryJobPostingCategory",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "topIndependentStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandCustomization",
            "kind": "LinkedField",
            "name": "brandCustomization",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandCustomizationLogo",
                "kind": "LinkedField",
                "name": "logo",
                "plural": false,
                "selections": [
                  (v27/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "tagContexts",
                "value": [
                  "SERVICE",
                  "PROJECT"
                ]
              },
              {
                "kind": "Literal",
                "name": "tagTypes",
                "value": [
                  "ROLE_TAG"
                ]
              }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v2/*: any*/),
              (v22/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "role",
                    "plural": false,
                    "selections": (v23/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "UserProfileRoleTag",
                "abstractKey": null
              }
            ],
            "storageKey": "tags(tagContexts:[\"SERVICE\",\"PROJECT\"],tagTypes:[\"ROLE_TAG\"])"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContraImage",
            "kind": "LinkedField",
            "name": "avatarImage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v12/*: any*/),
              (v10/*: any*/),
              (v39/*: any*/),
              (v13/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v35/*: any*/),
            "concreteType": "UserProfilePortfolioProjectConnection",
            "kind": "LinkedField",
            "name": "portfolioProjects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfilePortfolioProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v42/*: any*/),
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PortfolioProjectRoleConnection",
                        "kind": "LinkedField",
                        "name": "roles",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PortfolioProjectRoleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v24/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PortfolioProjectOrganizationConnection",
                        "kind": "LinkedField",
                        "name": "organizations",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PortfolioProjectOrganizationEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Organization",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v23/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "portfolioProjects(excludeDrafts:true,type:\"PROJECT\")"
          },
          {
            "alias": null,
            "args": (v43/*: any*/),
            "concreteType": "UserProfileProductizedServiceConnection",
            "kind": "LinkedField",
            "name": "productizedServices",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileProductizedServiceEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductizedService",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductizedServicePortfolioProjectConnection",
                        "kind": "LinkedField",
                        "name": "portfolioProjects",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductizedServicePortfolioProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PortfolioProject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "productizedServices(excludeDrafts:true)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileExternalLinkConnection",
            "kind": "LinkedField",
            "name": "externalLinks",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileExternalLinkEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfileExternalLink",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SocialMediaSite",
                        "kind": "LinkedField",
                        "name": "socialMediaSite",
                        "plural": false,
                        "selections": (v48/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IndependentPortfolioTemplateTheme",
            "kind": "LinkedField",
            "name": "independentPortfolioTemplateTheme",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IndependentPortfolioTemplate",
                "kind": "LinkedField",
                "name": "template",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ThemeCustomization",
                "kind": "LinkedField",
                "name": "themeCustomization",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeFontPack",
                    "kind": "LinkedField",
                    "name": "accentFontPack",
                    "plural": false,
                    "selections": (v48/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "backgroundColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeBackgroundStyle",
                    "kind": "LinkedField",
                    "name": "backgroundStyle",
                    "plural": false,
                    "selections": (v48/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeFontPack",
                    "kind": "LinkedField",
                    "name": "bodyFontPack",
                    "plural": false,
                    "selections": (v48/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fontColorPrimary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fontColorSecondary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeFontPack",
                    "kind": "LinkedField",
                    "name": "fontPack",
                    "plural": false,
                    "selections": (v48/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeFontPack",
                    "kind": "LinkedField",
                    "name": "headingFontPack",
                    "plural": false,
                    "selections": (v48/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomizationLayout",
                    "kind": "LinkedField",
                    "name": "layout",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ThemeProjectLayout",
                        "kind": "LinkedField",
                        "name": "projectsVariant",
                        "plural": false,
                        "selections": (v48/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ThemeServiceLayout",
                        "kind": "LinkedField",
                        "name": "servicesVariant",
                        "plural": false,
                        "selections": (v48/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContraImage",
                    "kind": "LinkedField",
                    "name": "logoImage",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v12/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserReviewConnection",
            "kind": "LinkedField",
            "name": "userReviews",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserReviewEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserReview",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commentOnlyVisibleToRecipient",
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reviewText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfile",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v2/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v30/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "onboardingType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContraImage",
                            "kind": "LinkedField",
                            "name": "avatarImage",
                            "plural": false,
                            "selections": (v51/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContraImage",
                                "kind": "LinkedField",
                                "name": "logoImage",
                                "plural": false,
                                "selections": (v51/*: any*/),
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserReviewAssociatedWork",
                        "kind": "LinkedField",
                        "name": "associatedWork",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PaidProjectProfile",
                            "kind": "LinkedField",
                            "name": "paidProjectProfile",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserProfile",
                                "kind": "LinkedField",
                                "name": "client",
                                "plural": false,
                                "selections": (v36/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PortfolioProject",
                            "kind": "LinkedField",
                            "name": "portfolioProject",
                            "plural": false,
                            "selections": (v36/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductizedService",
                            "kind": "LinkedField",
                            "name": "productizedService",
                            "plural": false,
                            "selections": (v36/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "url",
            "variableName": "url"
          }
        ],
        "concreteType": "UrlMetaData",
        "kind": "LinkedField",
        "name": "urlMetaData",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "twitterImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canonicalUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "openGraphImageAltText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UrlMetadataImageDimensions",
            "kind": "LinkedField",
            "name": "openGraphImageDimensions",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IndependentPortfolioTemplateConnection",
        "kind": "LinkedField",
        "name": "independentPortfolioTemplates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IndependentPortfolioTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IndependentPortfolioTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v50/*: any*/),
                  (v49/*: any*/),
                  (v52/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessLevel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IndependentPortfolioTemplateThemeConnection",
                    "kind": "LinkedField",
                    "name": "themes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IndependentPortfolioTemplateThemeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IndependentPortfolioTemplateTheme",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v50/*: any*/),
                              (v49/*: any*/),
                              (v52/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "generatedPreviewImage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContraImage",
                                "kind": "LinkedField",
                                "name": "previewImage",
                                "plural": false,
                                "selections": (v26/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0dc656f00d10847beefcd8806f98f6be",
    "id": null,
    "metadata": {},
    "name": "ServicePageQuery",
    "operationKind": "query",
    "text": "query ServicePageQuery(\n  $slug: String!\n  $url: String!\n  $username: String!\n) {\n  productizedServiceBySlug(slug: $slug) {\n    id\n    analyticsId\n    slug\n    title\n    blocknoteContent\n    visitorCanEdit\n    portfolioProjects {\n      edges {\n        node {\n          id\n          title\n          slug\n          cover {\n            __typename\n            ... on PortfolioProjectImageCover {\n              __typename\n              image {\n                id\n                animated\n                height\n                originalFormat\n                sizeBytes\n                uid\n                width\n              }\n            }\n            ... on PortfolioProjectTextCover {\n              __typename\n              style\n            }\n          }\n        }\n      }\n    }\n    deliverables {\n      edges {\n        node {\n          id\n          createdAt\n          description\n          sortOrder\n          title\n        }\n      }\n    }\n    price {\n      type\n      interval\n      amount\n      timeline\n    }\n    roles {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    tools {\n      edges {\n        node {\n          id\n          name\n          logoImage {\n            id\n            uid\n          }\n        }\n      }\n    }\n    userProfile {\n      id\n      displayUsername\n      firstName\n      lastName\n      generalInquiryCtaIsVisible\n      portfolioProjects(type: PROJECT, excludeDrafts: true) {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n      externalLinks {\n        edges {\n          node {\n            id\n            label\n            url\n            socialMediaSite {\n              nid\n              id\n            }\n          }\n        }\n      }\n      ...Services_userProfile\n      ...Footer_userProfile\n    }\n    ...Service_productizedService\n  }\n  userProfileByUsername(username: $username) {\n    id\n    ...UserProfile_userProfile\n  }\n  ...UrlMetaData_queryFragment\n  ...IndependentPortfolioTemplates_queryFragment\n}\n\nfragment Footer_userProfile on UserProfile {\n  id\n  visitorCanEdit\n  portfolioProjects(type: PROJECT, excludeDrafts: true) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  productizedServices(excludeDrafts: true) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  userReviews {\n    edges {\n      node {\n        id\n        onlyVisibleToRecipient\n        isPositiveReview\n      }\n    }\n  }\n}\n\nfragment IndependentPortfolioTemplates_queryFragment on Query {\n  independentPortfolioTemplates {\n    edges {\n      node {\n        id\n        displayName\n        developmentSlug\n        isLive\n        accessLevel\n        themes {\n          edges {\n            node {\n              id\n              displayName\n              developmentSlug\n              isLive\n              generatedPreviewImage\n              previewImage {\n                id\n                uid\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ServiceHeader_productizedService on ProductizedService {\n  id\n  title\n  price {\n    type\n    interval\n    amount\n    timeline\n  }\n  tags {\n    __typename\n    ... on Role {\n      id\n      name\n    }\n    ... on Tool {\n      id\n      name\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on IndustryCategory {\n      id\n    }\n    ... on ProductCustomTag {\n      id\n    }\n  }\n}\n\nfragment Service_productizedService on ProductizedService {\n  analyticsId\n  id\n  slug\n  productizedServiceType\n  duration {\n    amount\n    interval\n  }\n  title\n  blocknoteContent\n  portfolioProjects {\n    edges {\n      node {\n        analyticsId\n        id\n        title\n        slug\n        cover {\n          __typename\n          ... on PortfolioProjectImageCover {\n            __typename\n            image {\n              id\n              animated\n              height\n              originalFormat\n              sizeBytes\n              uid\n              width\n            }\n          }\n          ... on PortfolioProjectTextCover {\n            __typename\n            style\n          }\n        }\n      }\n    }\n  }\n  faqs {\n    edges {\n      node {\n        id\n        question\n        answer\n      }\n    }\n  }\n  deliverables {\n    edges {\n      node {\n        id\n        createdAt\n        description\n        sortOrder\n        title\n      }\n    }\n  }\n  price {\n    type\n    interval\n    amount\n    timeline\n  }\n  tags {\n    __typename\n    ... on Role {\n      id\n      name\n    }\n    ... on Tool {\n      id\n      name\n      logoImage {\n        id\n        uid\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on IndustryCategory {\n      id\n    }\n    ... on ProductCustomTag {\n      id\n    }\n  }\n  userProfile {\n    id\n    displayUsername\n    firstName\n    generalInquiryCtaIsVisible\n    portfolioProjects(type: PROJECT, excludeDrafts: true) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    productizedServices(excludeDrafts: true) {\n      edges {\n        node {\n          analyticsId\n          id\n          slug\n          title\n          portfolioProjects {\n            edges {\n              node {\n                analyticsId\n                id\n                title\n                slug\n                cover {\n                  __typename\n                  ... on PortfolioProjectImageCover {\n                    __typename\n                    image {\n                      id\n                      animated\n                      height\n                      originalFormat\n                      sizeBytes\n                      uid\n                      width\n                    }\n                  }\n                  ... on PortfolioProjectTextCover {\n                    __typename\n                    style\n                  }\n                }\n              }\n            }\n          }\n          productizedServiceType\n          duration {\n            amount\n            interval\n          }\n          price {\n            type\n            interval\n            amount\n            timeline\n          }\n        }\n      }\n    }\n    externalLinks {\n      edges {\n        node {\n          id\n          label\n          url\n          socialMediaSite {\n            nid\n            id\n          }\n        }\n      }\n    }\n    ...Services_userProfile\n    ...Footer_userProfile\n  }\n  ...ServiceHeader_productizedService\n}\n\nfragment Services_userProfile on UserProfile {\n  productizedServices(excludeDrafts: true) {\n    edges {\n      node {\n        analyticsId\n        id\n        slug\n        title\n        portfolioProjects {\n          edges {\n            node {\n              analyticsId\n              id\n              title\n              slug\n              cover {\n                __typename\n                ... on PortfolioProjectImageCover {\n                  __typename\n                  image {\n                    id\n                    animated\n                    height\n                    originalFormat\n                    sizeBytes\n                    uid\n                    width\n                  }\n                }\n                ... on PortfolioProjectTextCover {\n                  __typename\n                  style\n                }\n              }\n            }\n          }\n        }\n        productizedServiceType\n        duration {\n          amount\n          interval\n        }\n        price {\n          type\n          interval\n          amount\n          timeline\n        }\n      }\n    }\n  }\n}\n\nfragment UrlMetaData_queryFragment on Query {\n  urlMetaData(url: $url) {\n    title\n    description\n    facebookImageUrl\n    twitterImageUrl\n    canonicalUrl\n    openGraphImageAltText\n    updatedAt\n    openGraphImageDimensions {\n      width\n      height\n    }\n  }\n}\n\nfragment UserProfile_userProfile on UserProfile {\n  id\n  analyticsId\n  displayUsername\n  firstName\n  lastName\n  location\n  profileDisplayType\n  title\n  bio\n  visitorCanEdit\n  generalInquiryCtaIsVisible\n  hasActivePortfolio\n  primaryJobPostingCategory\n  topIndependentStatus\n  brandCustomization {\n    logo {\n      logoImage {\n        id\n        uid\n      }\n      id\n    }\n    id\n  }\n  tags(tagTypes: [ROLE_TAG], tagContexts: [SERVICE, PROJECT]) {\n    __typename\n    id\n    name\n    ... on UserProfileRoleTag {\n      role {\n        id\n        name\n      }\n    }\n  }\n  avatarImage {\n    id\n    uid\n    height\n    url\n    width\n    animated\n  }\n  portfolioProjects(type: PROJECT, excludeDrafts: true) {\n    edges {\n      node {\n        analyticsId\n        cover {\n          __typename\n          ... on PortfolioProjectImageCover {\n            __typename\n            image {\n              id\n              animated\n              height\n              originalFormat\n              sizeBytes\n              uid\n              width\n            }\n          }\n          ... on PortfolioProjectTextCover {\n            __typename\n            style\n          }\n        }\n        id\n        slug\n        title\n        roles {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        organizations {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n  productizedServices(excludeDrafts: true) {\n    edges {\n      node {\n        id\n        slug\n        title\n        portfolioProjects {\n          edges {\n            node {\n              id\n              slug\n            }\n          }\n        }\n        productizedServiceType\n        duration {\n          amount\n          interval\n        }\n        price {\n          type\n          interval\n          amount\n          timeline\n        }\n      }\n    }\n  }\n  externalLinks {\n    edges {\n      node {\n        id\n        label\n        url\n        socialMediaSite {\n          id\n          nid\n        }\n      }\n    }\n  }\n  independentPortfolioTemplateTheme {\n    id\n    developmentSlug\n    displayName\n    template {\n      id\n      developmentSlug\n      displayName\n    }\n    themeCustomization {\n      id\n      accentFontPack {\n        id\n        nid\n      }\n      backgroundColor\n      backgroundStyle {\n        id\n        nid\n      }\n      bodyFontPack {\n        id\n        nid\n      }\n      fontColorPrimary\n      fontColorSecondary\n      fontPack {\n        id\n        nid\n      }\n      headingFontPack {\n        id\n        nid\n      }\n      layout {\n        projectsVariant {\n          id\n          nid\n        }\n        servicesVariant {\n          id\n          nid\n        }\n      }\n      logoImage {\n        id\n        uid\n        sizeBytes\n      }\n    }\n  }\n  userReviews {\n    count\n    edges {\n      node {\n        id\n        commentOnlyVisibleToRecipient\n        createdAt\n        onlyVisibleToRecipient\n        isPositiveReview\n        reviewText\n        author {\n          analyticsId\n          id\n          firstName\n          lastName\n          displayUsername\n          onboardingType\n          avatarImage {\n            id\n            uid\n            url\n          }\n          organization {\n            name\n            logoImage {\n              id\n              uid\n              url\n            }\n            id\n          }\n        }\n        associatedWork {\n          paidProjectProfile {\n            id\n            client {\n              id\n            }\n          }\n          portfolioProject {\n            id\n          }\n          productizedService {\n            id\n          }\n        }\n        ...UserReview_userReview\n      }\n    }\n  }\n}\n\nfragment UserReview_userReview on UserReview {\n  id\n  commentOnlyVisibleToRecipient\n  createdAt\n  onlyVisibleToRecipient\n  isPositiveReview\n  reviewText\n  author {\n    analyticsId\n    id\n    firstName\n    lastName\n    displayUsername\n    onboardingType\n    avatarImage {\n      id\n      uid\n      url\n    }\n    organization {\n      name\n      logoImage {\n        id\n        uid\n        url\n      }\n      id\n    }\n  }\n  associatedWork {\n    paidProjectProfile {\n      id\n      client {\n        id\n      }\n    }\n    portfolioProject {\n      id\n    }\n    productizedService {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e4e2ed8911a9ab7377f581c27f373710";

export default node;
